import {
  getChannelObj,
  getChannelColorNameAndIcon,
  getTranslatedChannels,
  channels,
} from '@/utils/channels';

export default {
  data() {
    return {
      fourBigChannels: [
        'instagram',
        'facebook',
        'twitter',
        'youtube',
      ],
      channelsList: {},
    };
  },
  computed: {
    channels() {
      return channels;
    },
  },
  created() {
    this.channelsList = getTranslatedChannels();
  },
  methods: {
    getChannelObj(title) {
      return getChannelObj(title);
    },
    getChannelColorNameAndIcon(title) {
      const channelData = getChannelColorNameAndIcon(title);
      const normalizedKey = (title || 'notClassified')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/gu, '')
        .replace(/[^a-z0-9]/gu, '');
      const i18nKey = `mixins.channelModel.${normalizedKey}`;
      const translatedName = this.$te(i18nKey) ? this.$t(i18nKey) : channelData.name;
      return {
        ...channelData,
        name: translatedName,
      };
    },
  },
};
